import { buildModelManager } from "../builder.js";
const DefaultQuickQaGuidanceOverlaySelection = {
  __typename: true,
  id: true,
  agencyAliases: true,
  agencyName: true,
  content: { markdown: true, truncatedHTML: true },
  createdAt: true,
  domain: true,
  isActive: true,
  metadata: true,
  overlayKey: true,
  priority: true,
  scopeType: true,
  sourceType: true,
  stateCode: true,
  stateName: true,
  title: true,
  updatedAt: true,
  vectorStoreId: true
};
const modelApiIdentifier = "quickQaGuidanceOverlay";
const pluralModelApiIdentifier = "quickQaGuidanceOverlays";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuickQaGuidanceOverlaySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQuickQaGuidanceOverlaySelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaGuidanceOverlaySelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaGuidanceOverlaySelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaGuidanceOverlaySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaGuidanceOverlaySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaGuidanceOverlaySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByOverlayKey",
    findByField: "overlayKey",
    findByVariableName: "overlayKey",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaGuidanceOverlaySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByOverlayKey",
    findByField: "overlayKey",
    findByVariableName: "overlayKey",
    modelApiIdentifier,
    defaultSelection: DefaultQuickQaGuidanceOverlaySelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "quickQaGuidanceOverlayGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QuickQaGuidanceOverlayManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQuickQaGuidanceOverlaySelection,
  operations
);
export {
  DefaultQuickQaGuidanceOverlaySelection,
  QuickQaGuidanceOverlayManager
};
//# sourceMappingURL=QuickQaGuidanceOverlay.js.map
